<template lang="pug">
    .products-template
        .products-template-title
            |   {{ lenguageSelected.title }}
            img(:src="image")
        .products-template-content
            .products-template-content-title.blue
                |   {{ lenguageSelected.content1 }}
            p(v-for="data in lenguageSelected.contents2")   {{ data }}
            ul
                li(v-for="item in lenguageSelected.list")  {{ item }}
            .products-template-box               
                p(v-for="data in lenguageSelected.contents3")   {{ data }}
            p  {{ lenguageSelected.content4 }}
</template>

<script>
import image from '@img/products/BannerSecundario_SmallCells.jpg'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            image: image,
            lenguage: 'EN',
            lenguageEN: {
                title: 'Our small cell solutions deliver the coverage and capacity that mobile operators require to meet rising demand for connectivity in both indoor and outdoor settings.',
                content1: 'Enabling Advanced Mobile Connectivity with Outdoor Distributed Networks',
                contents2: [
                    'ATP’s Outdoor Distributed Networks enable mobile connectivity and superior wireless service in urban settings.',
                    'These networks are ideal for communities with zoning requirements designed to maintain a specific aesthetic environment. Distributed Networks are an increasingly key component within the mobile ecosystem, as these networks provide superior visual and economic benefits, while addressing targeted coverage and capacity needs. ',
                    'We take a pragmatic and comprehensive approach to designing and building Distributed Networks. Our carrier-class solutions are architected to be future-proof, readily adapting to technology advancements. To ensure seamless deployment, ATP has a focused and highly experienced Community Relations team that works closely with the municipalities, local and state governments, utility companies, and communities where we operate.',
                    "Key Benefits of ATP's Outdoor Distributed Networks:"
                ],
                list: [
                    'Multi-carrier and multi-technology (CDMA, GSM, 3G, 4G LTE, 5G-ready) support',
                    'Improved Quality of Service in areas inadequately served by macro cell towers',
                    'Increased network scalability & rapid provisioning of additional network capacity',
                    'Time-to-market advantages due to the leadership of a dedicated and highly experienced team',
                    'Lower Total Cost of Ownership (TCO)'
                ],
                contents3: [
                    'Outdoor Distributed Network nodes are typically located on existing municipal or private infrastructure like utility poles, street lamps or traffic signals, which provides a high density of potential site candidates.',
                    'With the ability to place Distributed Network nodes almost anywhere, ATP is equipped to reach areas that are otherwise difficult to serve, or undersaturated in terms of network coverage or capacity.'
                ],
                content4: 'To learn more about how our small cell solutions can address your needs, click the “Contact Us” button to your left.'
            },

            lenguageES:{
                title: 'Nuestras soluciones de Small Cells brindan la cobertura y la capacidad que los operadores móviles requieren para satisfacer la creciente demanda de conectividad, en entornos tanto interiores como exteriores.',
                content1: 'Habilitamos la conectividad móvil avanzada con redes distribuidas en ambientes exteriores con alta concentración de usuarios.',
                contents2: [
                    'Las Small Cells agrupadas como una red distribuida en exteriores permiten una mayor conectividad móvil y un servicio inalámbrico superior en entornos urbanos.',
                    'Estas redes distribuidas son ideales para comunidades con estrictos requisitos de zonificación urbana, y están diseñadas para mantener un entorno estético. Las Small Cells son un componente cada vez más indispensable dentro del ecosistema móvil. Brindan beneficios visuales, económicos y al mismo tiempo, abordan las necesidades de cobertura y capacidad.',
                    'ATP tiene un enfoque práctico e integral para diseñar y construir redes distribuidas de Small Cells en exteriores. Nuestras soluciones, de clase internacional, están diseñadas para el futuro desde su despliegue inicial, y se adaptan fácilmente a los avances tecnológicos y a la co-ubicación.',
                    "En ATP como buscamos ofrecer implementaciones en tiempo y forma, contamos con un equipo de Relaciones con la Comunidad, altamente experimentado y enfocado, que trabaja en estrecha colaboración con los municipios, los gobiernos locales y estatales, las empresas de servicios públicos y las comunidades donde desplegamos nuestras redes distribuidas.",
                    'Beneficios de las redes distribuidas de Small Cells para exteriores de ATP:'
                ],
                list: [
                    'Soporte multi-operador y multi-tecnología (CDMA, GSM, 3G, 4G LTE, 5G-ready)',
                    'Mejora de la calidad de servicio en áreas inadecuadamente atendidas por macro sitios',
                    'Mayor escalabilidad de la red y rápido aprovisionamiento de capacidad de red adicional',
                    'Ventajas de tiempo de despliegue debido al liderazgo de un equipo dedicado y altamente experimentado',
                    'Menor costo total de propiedad (TCO – Total Cost of Ownership)'
                ],
                contents3: [
                    'Los nodos de la red distribuida en ambientes exteriores generalmente se ubican en infraestructura urbana existente, como postes de servicios públicos, luminarias o semáforos, lo cual proporciona una gran variedad de ubicaciones potenciales.',
                    'Con la capacidad de ubicar los nodos de la red distribuida de Small Cells en casi cualquier lugar, la cartera de ATP está equipada para alcanzar áreas que sean difíciles de atender y que requieran mejoras de cobertura.'
                ],
                content4: 'Para obtener más información sobre cómo nuestras soluciones de Small Cells pueden satisfacer sus requerimientos y necesidades, seleccione el boton de la izquierda para ir a la sección de contacto.'
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/PmSmallCells.vue